/* 손으로 굴려보고 정하는 숫자들.

   기준선이 낮아서 매번 오버만 뜬다거나, 배당이 짜다거나 하는 건
   실제로 몇 판 해봐야 안다. 그때마다 코드를 뒤지지 않아도 되게
   한 파일에 모아둔다. 여기 값만 바꾸고 배포하면 된다.

   ⚠️ [DB] 표시가 붙은 값은 sql/setup.sql에도 같은 숫자가 있다.
      화면과 서버가 어긋나면 "3,000까지 걸 수 있어요"라고 해놓고
      서버가 거절하는 꼴이 된다. 한쪽만 고치지 말 것.
      (rooms.test.js가 둘이 같은지 확인한다) */

/* ============================================================
   또또 - 총 킬 언더/오버
   ============================================================ */

/* 인당 몇 킬을 기준으로 볼 것인가.
   기준선 = round(이 값 × 인원) + 0.5  →  6명 53.5 · 8명 71.5 · 10명 89.5

   처음엔 7.5로 잡았는데(6명 45.5) 매번 오버만 떴다. 오버가 계속
   나오면 올리고, 언더만 나오면 내린다. 0.5씩 움직여보면 감이 온다. */
export const KILLS_PER_PLAYER = 8.9;

/* 인원을 아직 모를 때 보여줄 기본 기준선 */
export const DEFAULT_KILL_LINE = 53.5;

/* ============================================================
   또또 - 한 사람이 한 번에 걸 수 있는 최대 [DB]
   ============================================================ */

/* 마켓마다 한 사람이 한 번에 걸 수 있는 최대.
   null이면 상한 없음 (잔액까지 건다).

   퍼블과 언더/오버는 배당이 고정이라 상한이 없으면 한 방에 끝난다.
   승리팀은 걸린 돈을 나눠 갖는 방식이라 많이 걸수록 배당이 낮아져
   어느 정도 스스로 조절된다 - 다만 그건 '배당'이 조절되는 것이지
   '격차'가 조절되는 건 아니다. 전 재산을 걸어 맞히면 그대로 두 배다.
   방 안에서 끼꼬 차이가 너무 빨리 벌어지면 여기에 숫자를 넣으면 된다.

   sql/setup.sql의 place_bets에 같은 숫자가 있다.
   한쪽만 바꾸면 화면에서는 되는데 서버가 거절한다 (테스트가 대조한다) */
export const BET_CAP = {
  winner: null,
  first_blood: 1000,
  kills: 3000,
  /* 일반 게임 또또. 짝/홀과 우리팀/상대팀은 반반이라 언더오버와 같은 무게,
     첫 용은 배당이 커서 첫 킬과 같은 무게로 묶는다 */
  kills_parity: 3000,
  fb_side: 3000,
  dragon: 1000,
  /* 우리 팀·상대 팀 킬 언더오버 */
  team_kills: 3000,
  /* 일반 게임 우리 팀 승리. 상대 팀 승리가 없어 한쪽으로만 몰리니 조금 낮게 */
  our_win: 2000,
};

/* 배팅 묶기. 담은 배팅의 배당을 곱한 한 장으로 건다.
   배당이 곱으로 커지니 한 번에 거는 끼꼬를 줄여야 한다 - 이 판에서 '버는'
   끼꼬(지급 - 건 돈)가 이 값을 넘지 않게, 거는 상한을 배당에서 거꾸로 구한다.
     상한 = floor(PARLAY_MAX_WIN / (묶음 배당 - 1))
   1.96 × 1.96(3.84배)이면 12,323까지, 7.0 × 5.5(38.5배)면 933까지.

   sql/setup.sql의 place_parlay에 같은 숫자가 있다 (테스트가 대조한다) */
export const PARLAY_MAX_WIN = 35000;

/* ============================================================
   일반 게임 또또 (내전 아님)
   ============================================================ */

/* 우리끼리 일반·칼바람 큐를 돌릴 때 거는 또또. 전적에는 안 들어간다.

   총 킬 기준선(양 팀 합계). 라이엇이 모드별 평균을 안 내놓고 통계 사이트도
   챔피언별 지표만 줘서, 공개된 숫자 없이 눈대중으로 잡았다.
   내전(KILLS_PER_PLAYER 8.9)은 이 방이 실제로 겪은 값이라 그걸 그대로
   쓰지 않았다 - 일반 큐는 그만큼 안 나온다.

   오버만 계속 뜨면 올리고 언더만 뜨면 내린다. 0.5씩 움직여보면 감이 온다. */
export const CASUAL_KILL_LINES = {
  /* 29.5로 잡았더니 매번 오버였다 */
  normal: 44.5,
  aram: 59.5,
};

/* 첫 킬을 누가 딸 것인가. 우리 팀 안에서의 몫이고 합이 1이다.
   서포터가 제일 어렵고 정글이 그다음, 탑·미드·원딜이 제일 쉽다.

   배당 = CASUAL_FB_RATE / (0.5 × 몫)
   상대팀이 딸 확률 절반을 먼저 떼고, 남은 절반을 이 몫으로 가른다.

   처음엔 내전 첫 킬과 같은 0.85에 서포터 몫 0.12로 잡았더니 서포터가
   14배가 넘었다. 몫의 차이를 줄이고(서포터 0.15) 깎는 폭을 키웠다(0.7).
     서폿 9.33 · 정글 7.37 · 탑 6.67 · 미드·원딜 6.22 · 미정 7.00
   칼바람은 라인이 없어서 다섯이 똑같이 0.2로 본다.

   sql/setup.sql의 casual_fb_odds에 같은 숫자가 있다 (테스트가 대조한다) */
export const CASUAL_FB_RATE = 0.7;

/* 티어 보정. 골드를 1.00으로 두고 한 칸 낮을 때마다 이만큼 배당을 올린다
   (높으면 내린다). 랭크가 낮으면 첫 킬을 딸 확률도 낮다.
   내전(2%)보다 크게 잡았다 - 일반 큐는 상대 티어가 우리와 비슷하게 잡혀서
   우리 쪽 실력 차이가 첫 킬에 그대로 드러난다.
     아이언 +12% · 실버 +4% · 골드 0 · 에메랄드 -8% · 그마 -20%
   sql/setup.sql의 casual_fb_odds에 같은 숫자가 있다 */
export const CASUAL_FB_TIER_BONUS = 0.04;

export const FIRST_BLOOD_LANE_SHARE = {
  TOP: 0.21,
  JUNGLE: 0.19,
  MID: 0.225,
  ADC: 0.225,
  SUPPORT: 0.15,
};

/* 첫 용. 여섯 종류라 본전은 6.0인데 조금 깎는다 (방이 본전이면 걸 이유가
   없고, 방이 손해면 끼꼬가 불어난다) */
export const FIRST_DRAGON_ODDS = 5.5;

/* ============================================================
   또또 - 배당 [DB]
   ============================================================ */

/* 여기 값은 '화면에 얼마라고 적을지'만 정한다.
   실제 지급 배당은 sql/setup.sql의 lock_betting이 계산한다.
   숫자를 바꾸려면 양쪽을 같이 고쳐야 한다.

   퍼블: 인원 × FIRST_BLOOD_RATE 가 기본 배당.
        6명이면 6 × 0.85 = 5.1배. 1.0으로 두면 딴 사람이 다 가져가고
        방 전체로는 본전이라, 조금 깎아서 '걸면 손해'가 되게 해둔다.
        티어가 한 칸 낮을 때마다 TIER_BONUS만큼 더 준다. */
export const FIRST_BLOOD_RATE = 0.85;
export const FIRST_BLOOD_TIER_BONUS = 0.02;

/* 실제로 퍼블을 많이 따는 사람은 배당을 '조금' 낮춘다.

   조금이 중요하다. 퍼블은 한 판에 한 번뿐이라 표본이 아주 느리게 쌓이고,
   몇 판 안 한 사람의 비율은 사실상 우연이다. 그래서 세 겹으로 묶어뒀다.
     1) 순위표와 같은 판수 보정(PRIOR_GAMES)으로 평균 쪽으로 먼저 당기고
     2) 평균의 2배를 따는 사람이어야 TILT(3%)만큼 내려가고
     3) 아무리 치우쳐도 CLAMP(±5%)를 못 넘는다.
   티어 보정(한 칸당 2%)과 비슷하거나 작은 크기다.

   6명 기준 5.10배가
     평균대로 따는 사람   → 5.10
     평균의 2배로 따는 사람 → 4.95 (-3%)
     평균의 3배로 따는 사람 → 4.85 (하한에 걸림)
   더 티 나게 하고 싶으면 TILT를, 폭을 넓히려면 CLAMP를 건드린다. */
export const FIRST_BLOOD_RATE_TILT = 0.03;
export const FIRST_BLOOD_TILT_CLAMP = { min: 0.95, max: 1.05 };

/* 언더/오버는 반반이라 2.0이 본전. 살짝 깎아 1.96을 기준으로 둔다.

   기준만 있고 안 움직이면 뻔한 쪽에 다 걸고 끝이라 고를 이유가 없다.
   그래서 몰린 만큼 배당이 따라 움직인다. 다만 승리팀처럼 걸린 돈을
   100% 나눠 갖는 방식은 아니다 - 기준값에서 지수로 눌러주기만 한다.
     배당 = KILLS_ODDS × (0.5 / 그쪽 비중) ^ KILLS_SHADE
   반반이면 정확히 1.96. 8:2면 몰린 쪽 1.55, 반대쪽은 상한에 걸려 3.00.
   한쪽에만 걸렸으면 1.40.

   SHADE를 1로 올리면 거의 패리뮤추얼, 0으로 내리면 옛날처럼 고정이다.
   지급을 시스템이 책임지는 마켓이라(제로섬이 아니다) 위아래를 묶어둔다.
   상한이 없으면 반대쪽에 한 명이 조금 걸어두는 것만으로 배당이 튄다. */
export const KILLS_ODDS = 1.96;
export const KILLS_SHADE = 0.5;
export const KILLS_ODDS_RANGE = { min: 1.3, max: 3.0 };

/* ============================================================
   또또 - 마감 타이머
   ============================================================ */

/* 또또를 열 때 고를 수 있는 시간(초). null = 방장이 직접 닫을 때까지 */
export const CLOSE_PRESETS = [
  { label: '직접 마감', seconds: null },
  { label: '1분', seconds: 60 },
  { label: '2분', seconds: 120 },
  { label: '3분', seconds: 180 },
  { label: '5분', seconds: 300 },
  { label: '10분', seconds: 600 },
];

/* 몇 초 남았을 때 숫자를 키워 서두르게 할 것인가 */
export const WARN_SECONDS = 20;

/* 몇 초 전부터 카드 색이 초록 → 빨강으로 옮겨갈 것인가 */
export const HEAT_SECONDS = 30;

/* 배팅 금액 빠른 입력 단추 */
/* 3000이 상한인 항목이 많아서(언더오버·짝홀·어느 팀) 한 번에 채우게 */
export const BET_BUMPS = [100, 500, 1000, 2000, 3000];

/* ============================================================
   내전 포인트 (전적 리더보드의 ±)
   ============================================================ */

/* 한 판으로 움직일 수 있는 최대 폭. 크게 잡으면 한 판에 순위가 뒤집힌다 */
export const K_FACTOR = 3;

/* 점수 차이가 이만큼 나면 승률 차이가 뚜렷해진다.
   작게 잡을수록 '센 팀을 이겼을 때' 보상이 커진다 */
export const ELO_SCALE = 14;

/* 판수가 이만큼 쌓여야 결과를 절반쯤 믿는다.
   2판 2승이 20판 15승보다 위로 가면 곤란하니 둔 장치 */
export const PRIOR_GAMES = 3;

/* ============================================================
   칭호 (이름 옆에 붙는 별명)
   ============================================================ */

/* 몇 연승/연패부터 붙일 것인가. 낮추면 아무나 받아서 값이 없어진다 */
export const TITLE_MIN_STREAK = 3;

/* 짝꿍·천적을 따질 때 최소 몇 판을 같이 뛰어야 하는가 */
export const TITLE_MIN_PAIR = 3;

/* 방의 마지막 경기로부터 며칠 안 보이면 '유령'인가 */
export const TITLE_GHOST_DAYS = 14;

/* '에이스'(승률왕). 판수가 적으면 승률은 그냥 우연이라 최소 판수를 둔다.
   방에서 한 명만 받는다 - 조건을 넘긴 사람 중 제일 높은 승률 */
export const TITLE_ACE_GAMES = 6;
export const TITLE_ACE_RATE = 0.65;

/* '올빼미'. 새벽(0~5시)에 뛴 판이 이 비율을 넘으면.
   내전은 원래 밤에 하는 놀이라 기준을 자정 뒤로 잡는다 */
export const TITLE_NIGHT_GAMES = 4;
export const TITLE_NIGHT_RATE = 0.6;

/* ============================================================
   참여 보상 · 시즌 [DB]
   ============================================================ */

/* 아래 값들은 전부 sql/setup.sql 안에서만 쓰인다.
   화면에 적어둘 일이 있을 때 여기서 가져다 쓰라고 적어둔다.
   진짜로 바꾸려면 setup.sql을 고치고 다시 실행해야 한다. */
export const SCRIM_REWARD = { win: 1500, lose: 1000 }; // award_participation
export const MONTHLY_KKIKO = 10000; // roll_season
export const ADJUST_CAP = 100000; // adjust_points, 한 번에 조정 가능한 폭

/* ============================================================
   명예의 전당 - 내전 1위 자격
   ============================================================ */

/* 두 판 뛰고 2승 한 사람이 그 달의 내전 왕이 되면 아무도 인정하지 않는다.
   내전 포인트에는 이미 판수 보정(PRIOR_GAMES)이 들어 있지만, 그건 점수를
   0쪽으로 당길 뿐이라 참가자가 적은 달에는 여전히 꼭대기에 설 수 있다.

   그래서 왕관에는 따로 문턱을 둔다.
     필요 판수 = max(HOF_MIN_GAMES, 올림(그 달 경기 수 × HOF_MIN_SHARE))

   비율로 잡는 이유: 한 달에 6판 한 방과 60판 한 방에 같은 숫자를 들이대면
   한쪽은 아무나 되고 한쪽은 아무도 못 된다.

   아무도 문턱을 못 넘으면 HOF_MIN_GAMES만 적용해서 한 명은 세운다.
   빈 왕좌보다는 낫다. */
export const HOF_MIN_GAMES = 3;
export const HOF_MIN_SHARE = 1 / 3;
